export default __webpack_public_path__ + "static/media/bn2.71e29c43.png";